import { AvailableBookingTimeWindow } from 'noddi-types';

export const mapToDeliveryWindow = (
  bookingTimeWindow: Pick<AvailableBookingTimeWindow, 'startsAt' | 'endsAt'> | null | undefined
) =>
  bookingTimeWindow
    ? {
        startsAt: bookingTimeWindow.startsAt,
        endsAt: bookingTimeWindow.endsAt
      }
    : undefined;
